export class SpeedTrialRequest {
    id: number;
    crewNumber: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
    points: number;
    stageResultId: number;

    constructor(
        id: number,
        crewNumber = 0,
        minutes = 0,
        seconds = 0,
        milliseconds = 0,
        points = 0,
        stageResultId = 0,
    ) {
        this.id = id;
        this.crewNumber = crewNumber;
        this.minutes = minutes;
        this.seconds = seconds;
        this.milliseconds = milliseconds;
        this.points = points;
        this.stageResultId = stageResultId;
    }
}

export class SpeedTrialPreRequest {
    crewNumber: number;
    stageId: number;
    stageResultId: number;

    constructor(
        crewNumber = 0,
        stageId = 0,
        stageResultId = 0,
    ) {
        this.crewNumber = crewNumber;
        this.stageId = stageId;
        this.stageResultId = stageResultId;
    }
}